// MapLibre 6 runs its tile worker from a URL, and once bundled it can't locate the
// file itself. public/assets/maplibre/ holds maplibre-gl-worker.mjs and the
// maplibre-gl-shared.mjs it imports, copied from node_modules/maplibre-gl/dist/.
// maplibre-gl is pinned: re-copy both files on every version bump, or the worker
// and the bundled library disagree and the maps break. Under /assets so the
// middleware leaves it alone.
export const MAPLIBRE_WORKER_URL = '/assets/maplibre/maplibre-gl-worker.mjs';
